<script>
    import R, {LOADER} from "../lib/requests";
    import {OBJECTS, SERVICE_TYPE} from "../lib/constants";
    import {formatDate} from "../lib/lib";
    import charges from "../stores/charges";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import ColoredNameControl from "../components/controls/ColoredNameControl.svelte";
    import Icon from "../components/icons/Icon.svelte";
    import ClientControl from "../components/controls/ClientControl.svelte";
    import ProjectSelectControl from "../components/controls/ProjectSelectControl.svelte";
    import ServiceSelectControl from "../components/controls/ServiceSelectControl.svelte";
    import ChargeObject from "../components/controls/ChargeObject.svelte";
    import SearchButtons from "../components/SearchButtons.svelte";
    import UserInitials from "../components/controls/UserInitials.svelte";
    import Alert from "../stores/alerts";

    const pageHeaderControls = [
        {key: 'create', name: 'ΔΗΜΙΟΥΡΓΙΑ'},
        {key: 'reload', name: '', icon: 'refresh'}
    ];

    const tableColumns = [
        {key: 'name', title: 'ΧΡΕΩΣΗ', sortable: true},
        {key: 'service', title: 'ΕΙΔΟΣ'},
        {key: 'client-project', title: 'ΠΕΛΑΤΗΣ/PROJECT'},
        {key: 'price', title: 'ΤΙΜΗ', sortable: true},
        {key: 'payment', title: 'ΠΛΗΡ.', sortable: true},
        {key: 'created_at', title: 'ΚΑΤΑΧ.', sortable: true, sort_way: 'DESC'},
        {key: 'user', title: '', sortable: false},
        {key: '', title: ''},
    ];

    let list = null;
    let total = 0;
    let totalPrice = 0;
    let totalPayment = 0;
    let totalRest = 0;
    let selectedId = null;
    let search = {
        start_at: '',
        end_at: '',
        object_type: OBJECTS.NONE,
        object_id: null,
        is_paid_off: '0',
        view: '',
        term: '',
        name: '',
        offset: 0,
        limit: 50,
        sort_field: '',
        sort_way: '',
    }
    let page = 1;

    const onCreate = () => {
        charges.create(null, null, null, closeEdit);
    };


    const load = (loader = LOADER.PAGE) => {
        const onSuccess = result => {
            list = result.list;
            total = result.totals.count;
            totalPrice = result.totals.price || 0;
            totalPayment = result.totals.payment || 0;
            totalRest = (totalPrice - totalPayment).toFixed(2);
        }

        const onFailure = err => {
        };

        search.offset = (page - 1) * search.limit;

        R.handle(R.charge.index, search, onSuccess, onFailure, loader);
    }


    const onColumnSort = ({detail}) => {
        search.sort_field = detail.key;
        search.sort_way = detail.sort_way;
        load();
    }

    const onEdit = (item) => {
        selectedId = item.id;
        charges.edit(item.id, closeEdit)
    }

    const closeEdit = (param) => {
        if (!param) {
            return;
        }

        load(LOADER.NONE);
    }

    const onDelete = (item) => {
        Alert.delete("Διαγραφή Χρέωσης", `Να διαγραφεί η χρέωση <strong>${item.name}</strong>;`, () => deleteItem(item.id));
    }

    const deleteItem = id => {
        const onSuccess = result => {
            load();
        }

        const onFailure = err => {
        };


        R.handle(R.charge.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    const onObjectTypeChange = () => {
        search.object_id = null;
        search.name = null;
        onSearch();
    }

    const clearSearch = () => {
        search.start_at = '';
        search.end_at = '';
        search.object_type = 0;
        search.object_id = 0;
        search.is_paid_off = '0';
        search.view = '';
        search.name = '';

        onSearch();
    }

    const onSearch = () => {
        page = 1;
        load();
    }

    load();
</script>

<PageHeader title="Χρεώσεις" controls={ pageHeaderControls } on:create={ onCreate } on:reload={ load }/>

<div class="panel-simple py-1 px-3 mb-5">
    <div class="row">
        <div class="col-xl-2 col-lg-2 col-md-3 col-6 p-1">
            <div class="form-control-container">
                <input type="date" class="form-control" bind:value="{ search.start_at }" on:change={ onSearch }>
                <div class="label">Από</div>
            </div>
        </div>
        <div class="col-xl-2 col-lg-2 col-md-3 col-6 p-1">
            <div class="form-control-container">
                <input type="date" class="form-control" bind:value="{ search.end_at }" on:change={ onSearch }>
                <div class="label">Έως</div>
            </div>
        </div>
        <div class="col-xl-2 col-lg-2 col-md-3 col-6 p-1">
            <div class="form-control-container">
                <select class="form-select" bind:value="{ search.is_paid_off }" on:change={ onSearch }>
                    <option value="">Όλες</option>
                    <option value="0">Εκκρεμείς</option>
                    <option value="1">Εξοφλημένες</option>
                </select>
                <div class="label">Κατάσταση</div>
            </div>
        </div>

        <div class="col-xl-2 col-lg-2 col-md-3 col-6 p-1">
            <div class="form-control-container">
                <select class="form-select" bind:value="{ search.object_type }" on:change={ onObjectTypeChange }>
                    <option value="{ OBJECTS.NONE }">Όλες</option>
                    <option value="{ OBJECTS.CLIENT }">Πελάτης</option>
                    <option value="{ OBJECTS.PROJECT }">Project</option>
                    <option value="{ OBJECTS.SERVICE }">Υπηρεσία</option>
                    <option value="{ OBJECTS.SUBSCRIPTION }">Συνδρομή</option>
                    <option value="{ OBJECTS.TASK }">Εργασία</option>
                </select>
                <div class="label">Είδος</div>
            </div>
        </div>

        <div class="col-xl-3 col-lg-4 col-md-6 col-6 p-1">
            {#if search.object_type === OBJECTS.NONE }
                <input type="text" class="form-control" bind:value="{ search.name }" on:change={ onSearch }
                       placeholder="όνομα χρέωσης">
            {:else if search.object_type === OBJECTS.CLIENT}
                <ClientControl bind:clientId={ search.object_id } allowCreate={ false } on:select={ onSearch }/>
            {:else if search.object_type === OBJECTS.PROJECT}
                <ProjectSelectControl bind:projectId={ search.object_id } on:change={ onSearch }/>
            {:else if search.object_type === OBJECTS.SERVICE}
                <ServiceSelectControl bind:serviceId={ search.object_id } serviceType={SERVICE_TYPE.NORMAL} on:change={ onSearch } labelOnTop
                                      placeholder="υπηρεσία"/>
            {:else if search.object_type === OBJECTS.SUBSCRIPTION}
                <ServiceSelectControl bind:serviceId={ search.object_id } serviceType={SERVICE_TYPE.SUBSCRIPTION} on:change={ onSearch } labelOnTop
                                      placeholder="υπηρεσία"/>
            {:else if search.object_type === OBJECTS.TASK}
                <input type="text" class="form-control" bind:value="{ search.name }" on:change={ onSearch }
                       placeholder="όνομα χρέωσης">
            {/if}
        </div>

        <div class="col-xl-1 p-1">
            <SearchButtons searchCallBack={ onSearch } clearCallback={ clearSearch }/>
        </div>
    </div>
</div>

{#if list !== null}
    {#if list.length}
        <table class="table table-list table-list-border mb-4">
            <TableHeader {tableColumns} on:sort={ onColumnSort }/>
            <tbody>
            {#each list as item}
                <tr class="row-hover" class:row-selected="{ selectedId === item.id }">
                    <td>
                        <button class="btn-reset is-link" on:click={ () => onEdit(item) }>
                            { item.name }
                        </button>
                    </td>
                    <td class="text-gray">
                        <ChargeObject object="{ item.object }"/>
                    </td>
                    <td class="text-gray">
                        {#if item.client}
                            {item.client.name}
                        {:else if item.project}
                            <ColoredNameControl name={item.project.name} color={item.project.color}/>
                        {/if}
                    </td>
                    <td class="price-column text-gray text-end">
                        { item.price }
                    </td>
                    <td class="price-column text-gray text-end">
                        { item.payment }
                    </td>
                    <td class="date-column text-gray text-end">
                        { formatDate(item.created_at, 'd-m-y') }
                    </td>
                    <td class="user-md-column text-gray px-2 py-0">
                        <UserInitials userId={item.user_id} md />
                    </td>
                    <td class="button-column">
                        <button class="button" title="διαγραφή" on:click="{ () => onDelete(item)  }">
                            <Icon icon="trash"/>
                        </button>
                    </td>
                </tr>
            {/each}
            </tbody>
        </table>
        {#if totalPrice || totalPayment}
            <div class="text-end mb-4">
                Σύνολο: <strong>{ totalPrice }</strong>, Πληρωμή: <strong>{ totalPayment }</strong>, Υπόλοιπο:
                <strong>{ totalRest }</strong>
            </div>
        {/if}
    {:else}
        <p>
            Δεν βρέθηκαν χρεώσεις!
        </p>
    {/if}
{/if}